module.exports = __webpack_public_path__ + "static/media/dhd670.27e2ddbf.jpg";